import React from 'react'
import { Link } from 'react-router-dom'

interface LogoProps extends React.SVGProps<SVGSVGElement> {
  className?: string
  link: string
}

const Logo: React.FC<LogoProps> = ({ className, link }) => {
  return (
    <Link to={link}>
      <svg
        className={className}
        width="52"
        height="52"
        viewBox="0 0 60 55"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_570_1167)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M55.9528 22.0626C55.5621 16.9799 53.792 12.1001 50.8334 7.94882L39.8754 15.7587C41.4132 17.9162 42.333 20.4523 42.5361 23.0939C42.7392 25.7355 42.2177 28.3825 41.0278 30.7496C39.838 33.1168 38.0249 35.1145 35.7837 36.5275C33.5426 37.9405 30.9584 38.7153 28.3096 38.7684C25.6608 38.8215 23.0476 38.151 20.7517 36.829C18.4557 35.5069 16.5639 33.5836 15.2801 31.266C13.9963 28.9485 13.3691 26.3246 13.4661 23.677C13.563 21.0294 14.3806 18.4584 15.8305 16.241L4.5682 8.87671C1.77835 13.1433 0.205403 18.0901 0.0187846 23.1843C-0.167834 28.2786 1.03895 33.3273 3.50915 37.7865C5.97934 42.2458 9.61936 45.9466 14.037 48.4903C18.4548 51.034 23.4827 52.3242 28.5794 52.222C33.6761 52.1198 38.6483 50.629 42.9605 47.9102C43.1154 47.8126 43.2691 47.7135 43.4218 47.613L51.9743 54.0465L59.9805 43.4033L52.5225 37.7931C52.705 37.4637 52.8812 37.1303 53.0508 36.793C55.3402 32.2383 56.3436 27.1453 55.9528 22.0626Z"
            fill="currentColor"
          />
          <path
            d="M24.1602 2.64316H32.2218V27.3568H24.1602V2.64316Z"
            fill="currentColor"
          />
          <mask
            id="mask0_570_1167"
            maskUnits="userSpaceOnUse"
            x="21"
            y="0"
            width="14"
            height="30"
          >
            <path d="M34.8636 0H21.5156V30H34.8636V0Z" fill="white" />
            <path
              d="M24.1602 2.64316H32.2218V27.3568H24.1602V2.64316Z"
              fill="none"
            />
          </mask>
          <g mask="url(#mask0_570_1167)">
            <path
              d="M24.1588 2.64317V0H21.5156V2.64317H24.1588ZM32.2205 2.64317H34.8636V0H32.2205V2.64317ZM32.2205 27.3568V30H34.8636V27.3568H32.2205ZM24.1588 27.3568H21.5156V30H24.1588V27.3568ZM24.1588 5.28634H32.2205V0H24.1588V5.28634ZM29.5773 2.64317V27.3568H34.8636V2.64317H29.5773ZM32.2205 24.7137H24.1588V30H32.2205V24.7137ZM26.802 27.3568V2.64317H21.5156V27.3568H26.802Z"
              fill="currentColor"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_570_1167">
            <rect width="60" height="54.0529" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Link>
  )
}

export default Logo
